import {matchPath} from 'react-router'

export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string) {
  const current = getCurrentUrl(pathname)
  if (!current || !url) {
    return false
  }

  if (current === url) {
    return true
  }

  if (current.indexOf(url) > -1) {
    return true
  }

  return false
}

export function isLinkActive(currentUrl: string, link: string) {
  currentUrl = getCurrentUrl(currentUrl)

  if (
    (currentUrl.includes('attendance') && currentUrl.includes('report')) ||
    (currentUrl.includes('attendance') && currentUrl.includes('setting')) ||
    (currentUrl.includes('attendance') && currentUrl.includes('biometricAttendanceUpload'))
  ) {
    currentUrl = currentUrl.substring(0, currentUrl.lastIndexOf('/'))
    link = link.substring(0, link.lastIndexOf('/'))
  }

  if (!currentUrl || !link) {
    return false
  }

  // if (currentUrl === link) {
  //   return true
  // }

  // if (currentUrl.indexOf(link) > -1) {
  //   return true
  // }

  return !!matchPath(currentUrl, link)
}

/**
 * Check if the given item has the given url
 * in one of its sub links
 *
 * @param subLinks
 * @param activeItem
 */
export const hasActiveSubLink = (subLinks: any[] | undefined, currentUrl: string) => {
  if (!subLinks || !Array.isArray(subLinks)) {
    return false
  }

  currentUrl = getCurrentUrl(currentUrl)

  for (const subLink of subLinks) {
    // A link the user cannot see must not open or highlight its group.
    if (subLink?.visible === false) {
      continue
    }

    if (subLink.subLinks) {
      if (hasActiveSubLink(subLink.subLinks, currentUrl)) {
        return true
      }
    }

    // Check if the child has a link and is active.
    //
    // Matched on path SEGMENTS, not as a substring: `/institute/exam/report`
    // is not the parent of `/institute/exam/report-cards`, and a plain
    // `includes` opened both exam groups at once on every report-card screen.
    if (
      subLink &&
      subLink.to &&
      currentUrl &&
      (subLink.to === currentUrl || currentUrl.startsWith(`${subLink.to}/`))
    ) {
      return true
    }
  }

  return false
}
